/* components/kitchen/TTKAnchorNav.jsx — навигация по разделам Р1–Р7 редактора ТТК.
   // заменяет: window.AnchorNav (Tabs.jsx, привязан к window-скроллу) —
   // здесь скролл-контейнер = .drawer__body (редактор живёт в drawer-стеке).
   Адаптив (классы; layout задаёт .ttk-map): md/lg — sticky-полоска сверху;
   xl — постоянная левая колонка-оглавление; xs/sm — не рендерится (см. TTKEditor).
   Активный раздел — IntersectionObserver. Клик — плавный скролл внутри контейнера.
   ХЕНДОФФ → frontend/src/components/ttk/AnchorNav.jsx. */

import React from 'react';

  const { useState, useEffect, useRef } = React;

  function TTKAnchorNav({ items = [], variant = 'bar' }) {
    const [active, setActive] = useState(items[0] && items[0].id);
    const navRef = useRef(null);
    const offset = variant === 'bar' ? 60 : 16; // высота sticky-полоски учтена при клике

    useEffect(() => {
      const navEl = navRef.current; if (!navEl) return;
      const scroller = navEl.closest('.entity-editor__content') || navEl.closest('.drawer__body') || null;
      const sections = items.map((i) => document.getElementById(i.id)).filter(Boolean);
      if (!sections.length) return;
      const io = new IntersectionObserver((entries) => {
        // активен самый верхний пересекающий раздел
        const visible = entries.filter((e) => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setActive(visible[0].target.id);
      }, { root: scroller, rootMargin: '0px 0px -65% 0px', threshold: 0 });
      sections.forEach((s) => io.observe(s));
      return () => io.disconnect();
    }, [items]);

    const go = (e, id) => {
      e.preventDefault();
      const navEl = navRef.current;
      const scroller = navEl ? (navEl.closest('.entity-editor__content') || navEl.closest('.drawer__body')) : null;
      const el = document.getElementById(id);
      if (!el) return;
      if (scroller) {
        const delta = el.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - offset;
        scroller.scrollTo({ top: delta, behavior: 'smooth' });
      } else {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      setActive(id);
    };

    return (
      <nav ref={navRef} className={'ttk-anchor ttk-anchor--' + variant} aria-label="Разделы ТТК">
        {items.map((it) => (
          <a key={it.id} href={'#' + it.id} onClick={(e) => go(e, it.id)}
            className={'ttk-anchor__item' + (active === it.id ? ' is-active' : '')}
            aria-current={active === it.id ? 'true' : undefined}>
            {it.num != null && <span className="ttk-anchor__num num">Р{it.num}</span>}
            <span className="ttk-anchor__label">{it.label}</span>
          </a>
        ))}
      </nav>
    );
  }

export { TTKAnchorNav };
